import { useState } from 'react';

import { Button } from '#/components/Button/Button';
import { Text } from '#/components/Text/Text';
import { TitleDescriptionModal } from '#/modules/salaries/modals/TitleDescription/TitleDescriptionModal';
import type { RidgeLineData } from '#/modules/salaries/types/RidgeLineData';

type ModalButtonProps = {
  item: RidgeLineData;
};

export function ModalButton({ item }: ModalButtonProps) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        type="button"
        noPadding
        onClick={() => setShowModal(true)}
        variant="tertiary"
        size="large"
      >
        <Text qaId="axis-tick" $lineClamp={2} textAlign="left">
          {item.name}
        </Text>
      </Button>
      {showModal ? (
        <TitleDescriptionModal
          onClose={() => setShowModal(false)}
          jobDescription={item.description}
          jobTitle={item.name}
        />
      ) : null}
    </>
  );
}
